




import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';
import { Activity } from '@activities/interfaces/activity';
import ActivitySingle from '@activities/components/singles/activity-single.vue';

@Component({
  name: 'bpc-activity-management-v2',
  components: {
    'bpc-activity-single': ActivitySingle,
  },
})
export default class ActivityManagementV2 extends Vue {
  // PROPS
  @Prop({ type: [Number, String] }) readonly id: number | string; // Received from url
  @Prop(Object) readonly initialData: Activity;

  // DATA
  // LIFECYCLE
  // created(){}
  // mounted(){}
  // updated(){}
  // destroyed(){}

  // COMPUTED
  get modelId(): number {
    console.log('ID', this.id);
    return Number(this.id);
  }

  // METHODS
  // WATCHERS
}
